import { Heading, Flex, Text, Skeleton, ChartIcon, CommunityIcon, SwapIcon } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import Image from 'next/image'
import useTheme from 'hooks/useTheme'
import { formatLocalisedCompactNumber } from 'utils/formatBalance'
import useSWRImmutable from 'swr/immutable'
// import IconCard, { IconCardData } from '../IconCard'
import IconStart, { IconCardData } from '../IconStart'
import SocialCardContent from './SocialCardContent'
import GradientLogo from '../GradientLogoSvg'
import Social from '../../../../../public/images/home/social.svg'

const SocialCard = () => {
  const { t } = useTranslation()
  const { theme } = useTheme()

  const { data: tvl } = useSWRImmutable('tvl')
  const { data: txCount } = useSWRImmutable('totalTx30Days')
  const { data: addressCount } = useSWRImmutable('addressCount30Days')
  const trades = formatLocalisedCompactNumber(txCount)
  const users = formatLocalisedCompactNumber(addressCount)
  const tvlString = tvl ? formatLocalisedCompactNumber(tvl) : '-'

  const tvlText = t('And those users are now entrusting the platform with over $%tvl% in funds.', { tvl: tvlString })
  const [entrusting, inFunds] = tvlText.split(tvlString)

  const UsersCardData: IconCardData = {
    icon: <Image src={Social} width="36px" />,
  }

  const TradesCardData: IconCardData = {
    icon: <Image src={Social} width="36px" />,
  }

  const StakedCardData: IconCardData = {
    icon: <Image src={Social} width="36px" />,
  }

  return (
    <Flex justifyContent="center" alignItems="center" flexDirection="column">
      {/* <GradientLogo height="48px" width="48px" mb="24px" /> */}
      <Heading textAlign="center" scale="xxl">
        {t('THE VOICE THAT')}
      </Heading>
      <Heading textAlign="center" scale="xxl" mb="32px" color="secondary">
        {t(' MATTERS ')}
      </Heading>
      <Text display="inline" textAlign="center" color="textSubtle" mb="50px" fontSize="24" fontWeight="600">
        Our unparalleled services reflect in testimonials from these users.
      </Text>
      {/* <Text textAlign="center" color="textSubtle">
        {t('PancakeSwap has the most users of any decentralized platform, ever.')}
      </Text> */}
      {/* <Flex flexWrap="wrap">
        <Text display="inline" textAlign="center" color="textSubtle" mb="20px">
          {entrusting}
          <>{tvl ? <>{tvlString}</> : <Skeleton display="inline-block" height={16} width={70} mt="2px" />}</>
          {inFunds}
        </Text>
      </Flex>

      <Text textAlign="center" color="textSubtle" bold mb="32px">
        {t('Will you join them?')}
      </Text> */}

      <Flex flexDirection={['column', null, null, 'row']}>
        <IconStart {...StakedCardData} mr={[null, null, null, '16px']} mb={['16px', null, null, null]}>
          <SocialCardContent
            headingText={t('')}
            bodyText={t(
              ' Including reducing the friction when switching between trading assets and among different asset classes.',
            )}
            bodyName={t('Eric Kripke')}
            highlightColor={theme.colors.secondary}
          />
        </IconStart>
        <IconStart {...TradesCardData} mr={[null, null, null, '16px']} mb={['16px', null, null, '0']}>
          <SocialCardContent
            headingText={t('')}
            bodyText={t(
              'Including reducing the friction when switching between trading assets and among different asset classes.',
            )}
            bodyName={t('Eric Kripke')}
            highlightColor={theme.colors.primary}
          />
        </IconStart>
        <IconStart {...UsersCardData} mr={['16px', '16px', '16px', '16px']} mb={['16px', '16px', '16px', '0']}>
          <SocialCardContent
            headingText={t('')}
            bodyName={t('Eric Kripke')}
            bodyText={t(
              'Including reducing the friction when switching between trading assets and among different asset classes.',
            )}
            highlightColor={theme.colors.failure}
          />
        </IconStart>
        <IconStart {...UsersCardData}>
          <SocialCardContent
            headingText={t('')}
            bodyName={t('Eric Kripke')}
            bodyText={t(
              'Including reducing the friction when switching between trading assets and among different asset classes.',
            )}
            highlightColor={theme.colors.failure}
          />
        </IconStart>
      </Flex>
      {/* kdvndk */}
    </Flex>
  )
}

export default SocialCard
